<template>
  <div class="row pricing">
    <div class="container">
      <section
        id="valores"
        class="section"
      >
        <div class="pricing-text">
          <h2
            id="pre-cadastro-com-desconto"
            class="huge"
          >
            Valores &amp; Taxas
          </h2>
          <p class="pricing-subtitle">
            Confira preços e condições para contratação em <strong>2020</strong>
          </p>
        </div>
        <div class="pricing-boxes-wrap">
          <div class="pricing-box">
            <div class="pre-campaign-box">
              <h3>Taxa única</h3>

              <p>Pré-campanha e campanha</p>

              <p class="box-currency">
                R$
              </p>
              <p class="box-price">
                495,
              </p>
              <p class="box-cents">
                00
              </p>
              <p class="box-price-subtitle">
                Parcela única para setup
              </p>
              <p class="box-price-information">
                   Plataforma para doação eleitoral em 2022
              </p>
            </div>

            <div class="fee-box fee-box--first">
              <p class="fee-box-title">
                + Taxas administrativas por doação:
              </p>
              <p class="fee-box-text">
                {{ creditCard }} via cartão de crédito
              </p>
              <p class="fee-box-text">
                {{ paymentSlip }} via boleto pago
              </p>
              <p class="fee-box-text">
                {{ paymentPix }} via pix
              </p>
            </div>
          </div>
          <!-- <div class="pricing-box">
            <div class="campaign-box">
              <h3>Campanha</h3>
              <p class="box-subtitle">
                (para quem contratou a pré-campanha com desconto)
              </p>
              <p class="box-currency">
                R$
              </p>
              <p class="box-price">
                99,
              </p>
              <p class="box-cents">
                00
              </p>
              <p class="box-price-subtitle">
                Parcela única para setup
              </p>
              <p class="box-price-information">
                OU R$495,00 pra quem NÃO contratou pré-campanha
              </p>
            </div>
            <div class="fee-box">
              <p class="fee-box-title">
                + Taxas administrativas por doação:
              </p>
              <p class="fee-box-text">
                {{ creditCard }} via cartão de crédito
              </p>
              <p class="fee-box-text">
                {{ paymentSlip }} via boleto pago
              </p>
              <p class="fee-box-text">
                Transferências semanais sem custo adicional, acima de R$ 300,00.
              </p>
            </div>
          </div> -->
        </div>
        <form
          id="call-to-buy"
          class="call-to-buy"
          target="_blank"
          @submit.prevent="submitForm"
        >
          <p>
            Solicite sua licença
          </p>

          <div
            class="input-wrapper"
            :class="errorMessage ? 'has-error' : ''"
          >
            <label
              for="email"
            >
              Seu melhor e-mail
            </label>
            <div class="input-and-message">
              <input
                id="email"
                v-model="email"
                type="email"
                name="email"
                required
              >
              <small
                v-if="errorMessage"
                class="message message--error"
              >
                {{ errorMessage }}
              </small>
              <small
                v-if="successMessage"
                class="message message--success"
              >
                {{ successMessage }}
              </small>
            </div>
            <button
              class="nav-link"
              type="submit"
              :disabled="loading"
            >
              Comprar
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import 'whatwg-fetch';

import CONFIG from "./../../config.js";

export default {
  data() {
    return {
      loading: false,
      email: '',

      creditCard: CONFIG.taxes.CREDIT_CARD_TEXT,
      paymentSlip: CONFIG.taxes.PAYMENT_SLIP_TEXT,
      paymentPix: CONFIG.taxes.PAYMENT_PIX_TEXT,
      promotionalPrice: __PROMOTIONAL_PRICE__,

      errorMessage: '',
      successMessage: '',

      discountedOfferingId: '26894679-ea65-4f93-a181-29e809638a98',

      validation: {
        errors: {
          zip_code: '',
        },
      },

      ref: '',
      pcLog: '',
      canRedirect: 1,
    };
  },

  computed: {
    api(){
      return window.location.host === 'votolegal.com.br'
      || window.location.host === 'votolegal.com'
      || window.location.host === '2018.votolegal.com.br'
      || window.location.host === '2018.votolegal.com'
        ? 'https://touchbase-api.appcivico.com'
        : 'https://dev-touchbase-api.appcivico.com';
    }
  },

  created() {
    this.ref = window.localStorage.getItem('ref') || this.$route.query.ref;

    this.pcLog = window.localStorage.getItem('pcLog');

    this.initTrackRefs();
  },

  methods: {
    initTrackRefs() {
      const apiRequestPath = `${this.api}/referrer-pageview`;
      const { ref, pcLog } = this;

      if (ref) {
        const data = { ref };

        if (pcLog) {
          data.pclog = pcLog;
        }

        fetch(apiRequestPath, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(data).toString(),
        })
          .then((response) => {
            const contentType = response.headers.get('content-type');
            if (!response.ok) {
              throw new Error(String(response.status));
            }

            if (!contentType || !contentType.includes('application/json')) {
              throw new Error('Oops, we haven\'t got JSON!');
            }

            return response.json();
          })
          .then((jsonData) => {
            if (jsonData.pclog) {
              this.pcLog = jsonData.pclog;
              window.localStorage.setItem('pclog', jsonData.pclog);
            }
          })
          .catch((err) => {
            throw new Error(err.message);
          });
      }
    },

    submitForm() {
      let submissionUrl = `${this.api}/quick_purchase/request_token`;

      // append querystring existing parameters to post
      // submissionUrl += `?querystring=${window.location.search}`;

      const { canRedirect, ref, pcLog } = this;

      const data = {
        email: this.email,
        discounted_offering_id: this.discountedOfferingId,
      };

      if (canRedirect) {
        data.can_redirect = this.canRedirect;
      }

      if (pcLog) {
        data.pclog = this.pcLog;
      }

      if (ref) {
        data.ref = this.ref;
      }

      data.querystring = location.search;

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      fetch(submissionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data).toString(),
      })
      .then((response) => {
        const contentType = response.headers.get('content-type');
        if (!response.ok) {
          return response.json().then((x) => { throw new Error(x.message); });
        }

        if (!contentType || !contentType.includes('application/json')) {
          this.errorMessage = 'Oops, we haven\'t got JSON!';

          throw new Error('Oops, we haven\'t got JSON!');
        }

        return response.json();
      })
      .then((jsonData) => {
        if (jsonData.redirect_to) {
          window.location = jsonData.redirect_to;
          return;
        }
        this.successMessage = jsonData.message || 'Solicitação efetivada com sucesso. Consulte a caixa de entrada de sua conta de email';
      })
      .catch((err) => {
        this.errorMessage = err.message;
        this.loading = false;
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.pricing {
  position: relative;

  width: 100%;

  text-align: center;

  color: white;

  background-image: url('../../img/pricing/bg-pricing-small.png');
  background-position: center 50%;
  background-size: 310px 306px;
  background-repeat: no-repeat;
  background-color: #1167ac;

  @media screen and (min-width: 450px) {
    background-image: url('../../img/pricing/bg-pricing.png');
    background-position: 60% 60%;
    background-size: 400px 395px;
  }

  @media screen and (min-width: 580px) {
    background-image: url('../../img/pricing/bg-pricing-big.png');
    background-position: center 58%;
    background-size: 550px 543px;
  }

  @media screen and (min-width: 980px) {
    background-size: 550px 543px;
  }
}

.pricing h2 {
  font-weight: bold;

  text-align: center;
}

.pricing p {
  text-align: center;
}

.section {
  overflow: hidden;
}

.pricing-text p {
  margin-top: 1em;
  margin-bottom: 1em;

  font-size: 25px;
}

.pricing-text strong {
  font-weight: bold;
}

.pricing-boxes-wrap {
  width: 100%;

  margin-top: 3rem;

  font-size: 0;
  letter-spacing: -0.31em;
  letter-spacing: normal\9;
  word-spacing: -0.43em\9;

  text-rendering: optimizespeed;
}

.pre-campaign-box,
.campaign-box {
  height: auto;
  max-width: 100%;

  padding: 2em;

  font-size: 1rem;

  text-align: center;
  text-transform: uppercase;

  background-color: #2078bc;

  border: dashed 2px white;
  border-radius: 3px;

  @media screen and (min-width: 500px) {
    width: 310px;
    height: 250px;

    margin-top: 1em;
    margin-right: 2.5em;
    margin-left: 2.5em;
  }
}

.pre-campaign-box h3 {
  margin-bottom: 0.9em;
}

.campaign-box {
  background-color: #0f5893;

}

.pricing-box,
.fee-box {
  position: relative;

  margin-bottom: 1rem;

  font-size: 1em;
  letter-spacing: normal;
  word-spacing: normal;

  text-rendering: auto;
  vertical-align: top;

  zoom: 1;

  @media screen and (min-width: 500px) {
    display: inline-block;
  }
}

.fee-box {
  @media screen and (min-width: 1024px) {
    min-height: 152px;
  }
}

.fee-box--first {
  @media screen and (min-width: 1024px) {
    padding-top: 20px;

    box-sizing: border-box;
  }
}

.pricing-box h3 {
  font-weight: bold;
  font-size: 23px;

  text-align: center;
  text-transform: uppercase;

  color: #ffffff;
}

.box-subtitle {
  margin-bottom: 0;

  font-weight: bold;
  font-size: 14px;

  color: #aadaff;
}

.full-price {
  font-size: xx-large;

  text-transform: lowercase;

  opacity: 0.75;
}

.full-price s {
  position: relative;

  display: inline-block;

  text-decoration: none;

  &::after {
    position: absolute;
    right: 0;
    bottom: 50%;
    left: 0;

    width: 100%;

    border-top: 2px solid currentColor;

    content: '';

    transform: skewY(-10deg);
  }
}

.box-currency {
  display: inline-block;

  margin-top: 0.5em;

  font-weight: bold;
  font-size: 35px;

  text-transform: uppercase;
}

.box-price {
  display: inline-block;

  margin-top: 15px;

  font-weight: bold;
  font-size: 65px;

  text-transform: uppercase;
}

.box-cents {
  display: inline-block;

  margin-top: 0.7em;
  margin-left: -0.1em;

  font-size: 35px;

  text-transform: uppercase;
  vertical-align: top;
}

.box-price-subtitle {
  width: 15em;

  margin-top: -0.5em;
  margin-right: auto;
  margin-left: auto;

  font-size: 14px;
}

.box-price-information {
  max-width: 20em;

  margin-top: 1em;
  margin-right: auto;
  margin-left: auto;
  text-transform: none;

  font-size: 13px;
}

.fee-box {
  display: block;

  width: 95%;

  margin-right: auto;
  margin-bottom: 2rem;
  margin-left: auto;

  font-weight: bold;
  font-size: 1em;
  line-height: 0.8em;

  background-color: #143d5d;

  opacity: 0.9;

  @media screen and (min-width: 500px) {
    width: 345px;

    margin-bottom: 2rem;
  }

  & span {
    font-size: 22px;

    color: white;
  }
}

.pricing-boxes-wrap .fee-box {
  margin-top: 0.5em;
  margin-bottom: 1em;
}

.fee-box-title {
  padding-top: 1em;
  padding-bottom: 0;
  margin: auto;

  font-weight: bold;

  text-align: center;

  @media screen and (max-width: 400px) {
    font-size: 15px;
  }

}

.fee-box-text {
  max-width: 18em;

  padding-top: 0;
  margin: auto;

  text-align: center;

  &:last-child {
    padding-bottom: 1em;
  }
}

.fee-box-text--footnote {
  width: 100%;
  max-width: none;

  margin-top: 1.5rem;

  font-size: 0.75rem;
  line-height: 1.5;
}

.img-pricing {
  position: relative;

  display: block;

  margin-right: auto;
  margin-left: auto;
}

.call-to-buy {
  width: 100%;

  margin-top: 1.5rem;
  margin-bottom: 0;

  text-align: center;

  @media screen and (min-width: 500px) {
    margin-top: 2.5rem;
  }
}

.call-to-buy p {
  margin-bottom: 2rem;

  font-size: 1.5em;
}

.call-to-buy p a {
  font-weight: bold;

  text-decoration: underline;

  color: #ffffff;
}

.input-wrapper {
  display: flex;

  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: center;

  margin-top: 1.5 * 0.25em;
  margin-bottom: 1.5 * 0.25em;

  input,
  .nav-link,
  label,
  small {
    display: flex;

    align-items: center;

    height: 3rem;

    padding-top: 0.5em;
    padding-right: 1.5em;
    padding-bottom: 0.5em;
    padding-left: 1.5em;
    margin-bottom: 3rem;

    line-height: 1.5rem;

    border-radius: 8px;

    box-sizing: border-box;
  }

  label,
  small {
    margin-bottom: 0;

    line-height: 1;
  }

  div {
    width: min-content;

    padding-right: 0.5em;
    padding-bottom: 3rem;
    padding-left: 0.5em;
  }

  input {
    width: 25em;
    max-width: 100%;

    margin-bottom: 0;

    border: 2px solid #ffffff;
  }
}

.nav-link {
  width: max-content;
  max-width: 100%;

  font-weight: bold;
  font-size: larger;

  text-align: center;

  cursor: pointer;

  color: white;

  background-color: #0aba7e;

  border: 0;
  border: 2px solid #0aba7e;
}

.input-wrapper label {
  padding-right: 0;
  padding-left: 0;

  font-weight: bold;
}

.message {
  display: block;

  padding-bottom: 0;
  margin-top: 0.5em;

  font-weight: bold;
  font-size: small;
  line-height: 1;

  border-radius: 8px;
}

.message--success {
  background-color: green;
}

.message--error {
  background-color: red;
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/pricingsection.vue